export const objectFromEntries = Object.fromEntries;
export const objectEntries = Object.entries;
export const objectKeys = Object.keys;
export const objectValues = Object.values;
export const objectIsEmpty = (obj) => objectValues(obj).filter((v) => v !== undefined && v !== null).length === 0;
/**
 * This is just a way to get TypeBox Static<> types to show up better in type inference. Ignore this type.
 */
class FixTsMappedTypes {
}
export const firstNameLastNameFromName = (name) => {
    // This isn't very exact at all as firstnames can have spaces in them
    // so this is just a best guess
    const parts = name.split(' ');
    const firstName = parts[0];
    const lastName = parts.slice(1).join(' ');
    return { firstName, lastName };
};
export const createRandomId = () => {
    var _a;
    if ((_a = globalThis.crypto) === null || _a === void 0 ? void 0 : _a.randomUUID) {
        return globalThis.crypto.randomUUID();
    }
    return `${numberToString(Math.random())}-${numberToString(Math.random())}-${numberToString(Date.now())}`;
};
const numberToString = (n) => n.toString(36).substring(2);
export const assertUnreachable = (_) => {
    throw new Error('Unreachable code reached');
};
export const toMinorUnits = (amount) => Math.round(amount * 100);
//# sourceMappingURL=utils.js.map